export default {
  ENTRY_INIT_AFTER_COMPETITION_CLOSED: 'Entry initiated after competition closed',
  ENTRY_PAYMENT_AFTER_COMPETITION_CLOSED: 'Entry payment initiated after competition closed'
}
